export default __webpack_public_path__ + "static/media/IMG_8766 - Abhishek.5c91a800.jpeg";